import { useCallback } from 'react'
import { AnalyticsEventEmitter } from 'Utils/Analytics/AnalyticsEventEmitter'

import { authorization } from 'Module/Auth/Auth'

const useCampaignPosthogAnalytics = posthog => {
  const emitAnalyticsEvent = useCallback(
    (eventName, campaignId, extraData = {}) => {
      if (!posthog) {
        return
      }
      const user = authorization.getUser()
      const eventEmitter = new AnalyticsEventEmitter(posthog)
      eventEmitter.run({
        eventName,
        userId: user.id,
        clientName: user.client.name,
        campaignId,
        additionalPayload: extraData,
      })
    },
    [posthog],
  )
  return { emitAnalyticsEvent }
}

export default useCampaignPosthogAnalytics
